var _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _rect4, _rect5, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountSynchronization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 75,
    width: 224,
    height: 135,
    rx: 4,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 92,
    width: 187,
    height: 100,
    fill: "#102F5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4767 232L32 275H318L286.523 232H63.4767Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4767 210L32 253H318L286.523 210H63.4767Z",
    fill: "#102F5D",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.566 232L127 247H223L212.434 232H137.566Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 253,
    width: 286,
    height: 22,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.838 95.0799C162.952 88.953 157.246 84.5 150.5 84.5C142.216 84.5 135.5 91.2157 135.5 99.5V127.5C135.5 135.784 142.216 142.5 150.5 142.5H178.5C186.784 142.5 193.5 135.784 193.5 127.5C193.5 123.243 191.727 119.401 188.879 116.671C192.993 115.263 197.406 114.5 202 114.5C216.954 114.5 230.024 122.601 237.048 134.689C239.73 139.306 244.786 143 251.018 143C260.921 143 269.986 132.671 264.289 121.953C252.454 99.6879 229.007 84.5 202 84.5C188.365 84.5 175.627 88.3759 164.838 95.0799Z",
    fill: "#102F5D",
    stroke: "white",
    strokeWidth: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 67.5,
    width: 97,
    height: 143,
    rx: 12.5,
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 87,
    width: 58,
    height: 104,
    fill: "#102F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.629 208.92C238.515 215.047 244.221 219.5 250.967 219.5C259.251 219.5 265.967 212.784 265.967 204.5V176.5C265.967 168.216 259.251 161.5 250.967 161.5H222.967C214.683 161.5 207.967 168.216 207.967 176.5C207.967 180.757 209.74 184.599 212.588 187.329C208.474 188.737 204.061 189.5 199.467 189.5C184.513 189.5 171.442 181.399 164.419 169.311C161.736 164.694 156.681 161 150.448 161C140.546 161 131.481 171.329 137.178 182.047C149.012 204.312 172.46 219.5 199.467 219.5C213.102 219.5 225.839 215.624 236.629 208.92Z",
    fill: "#102F5D",
    stroke: "white",
    strokeWidth: 15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242 87L242.833 88.4575C244.791 91.8849 248.436 94 252.384 94H263.616C267.564 94 271.209 91.8849 273.167 88.4575L274 87H242Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSynchronization);
export default __webpack_public_path__ + "static/media/account-synchronization.a04c4edb1509d15573adc1ceeb9d9a51.svg";
export { ForwardRef as ReactComponent };